import React, { useState } from 'react';
import { FilterSidebarWrapper } from '../UI/FilterSidebar';
import { TroveSidebar } from './TroveSidebar';
import { FilterSection } from '../UI/FilterSidebar';
import { FilterIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface TroveLayoutProps {
  children: React.ReactNode;
  filterSections?: FilterSection[];
  onResetFilters?: () => void;
  sidebarProps?: {
    showServiceCategories?: boolean;
  };
}
export const TroveLayout: React.FC<TroveLayoutProps> = ({
  children,
  filterSections = [],
  onResetFilters,
  sidebarProps = {}
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  return <div className={`min-h-screen flex flex-col ${dk.page}`} data-id="element-3526" data-mp="365itzjlro4kr">
      <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3527" data-mp="3b4bywnmzmn9b">
        <div className="lg:flex lg:gap-8" data-id="element-3528" data-mp="2j4fkvz90q8or">
          <FilterSidebarWrapper isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} data-id="element-3529" data-mp="2j45uiak29zij">
            <TroveSidebar filterSections={filterSections} onResetFilters={onResetFilters} showServiceCategories={sidebarProps.showServiceCategories} data-id="element-3530" data-mp="29cjbvt5e8y5r" />
          </FilterSidebarWrapper>

          <main className="flex-1 min-w-0" data-id="element-3531" data-mp="1veuzl9pe6zcb">
            <div className="lg:hidden mb-4" data-id="element-3532" data-mp="1vh7gdjjez3ns">
              <button onClick={() => setIsSidebarOpen(true)} className={`flex items-center px-4 py-2 rounded-md border shadow-sm text-sm font-medium transition-colors ${dk.card} ${rt.accentLink}`} data-id="element-3533" data-mp="1qfi6i77xgw1a">
                <FilterIcon className={`h-4 w-4 mr-2 ${rt.textPrimary}`} data-id="element-3534" data-mp="3kt9k1htdo020" />
                Menu & Filters
              </button>
            </div>
            {children}
          </main>
        </div>
      </div>
    </div>;
};